/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
    GuidIdCodeAndLabel,
    GuidIdCodeAndLabelFromJSON,
    GuidIdCodeAndLabelFromJSONTyped,
    GuidIdCodeAndLabelToJSON,
    Int32IdAndLabel,
    Int32IdAndLabelFromJSON,
    Int32IdAndLabelFromJSONTyped,
    Int32IdAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProviderCredentialFormData
 */
export interface ProviderCredentialFormData {
    /**
     * 
     * @type {string}
     * @memberof ProviderCredentialFormData
     */
    id?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderCredentialFormData
     */
    allowEdit?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderCredentialFormData
     */
    enabled?: boolean;
    /**
     * 
     * @type {BrandAndMarketListItem}
     * @memberof ProviderCredentialFormData
     */
    brandAndMarket?: BrandAndMarketListItem;
    /**
     * 
     * @type {Int32IdAndLabel}
     * @memberof ProviderCredentialFormData
     */
    channel?: Int32IdAndLabel;
    /**
     * 
     * @type {GuidIdCodeAndLabel}
     * @memberof ProviderCredentialFormData
     */
    agency?: GuidIdCodeAndLabel;
    /**
     * 
     * @type {GuidIdAndLabel}
     * @memberof ProviderCredentialFormData
     */
    provider?: GuidIdAndLabel;
    /**
     * 
     * @type {string}
     * @memberof ProviderCredentialFormData
     */
    username?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProviderCredentialFormData
     */
    password?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProviderCredentialFormData
     */
    secretName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProviderCredentialFormData
     */
    url?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProviderCredentialFormData
     */
    targetBranch?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProviderCredentialFormData
     */
    agencyId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProviderCredentialFormData
     */
    agentName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProviderCredentialFormData
     */
    agentPassword?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProviderCredentialFormData
     */
    agentSecretName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProviderCredentialFormData
     */
    pcc?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProviderCredentialFormData
     */
    subscriptionKey?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProviderCredentialFormData
     */
    subscriptionKeySecretName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProviderCredentialFormData
     */
    target?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProviderCredentialFormData
     */
    b2BAPIUserPasswordSecretName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProviderCredentialFormData
     */
    b2BAPIUserPassword?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProviderCredentialFormData
     */
    b2BAPIUserEmailAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProviderCredentialFormData
     */
    serviceUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProviderCredentialFormData
     */
    clientId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProviderCredentialFormData
     */
    clientSecret?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProviderCredentialFormData
     */
    authenticationUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProviderCredentialFormData
     */
    accessGroup?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProviderCredentialFormData
     */
    shoppingUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProviderCredentialFormData
     */
    shoppingClientId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProviderCredentialFormData
     */
    shoppingClientSecret?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProviderCredentialFormData
     */
    shoppingServiceUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProviderCredentialFormData
     */
    postShoppingUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProviderCredentialFormData
     */
    postShoppingClientId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProviderCredentialFormData
     */
    postShoppingClientSecret?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProviderCredentialFormData
     */
    postShoppingServiceUrl?: string | null;
}

export function ProviderCredentialFormDataFromJSON(json: any): ProviderCredentialFormData {
    return ProviderCredentialFormDataFromJSONTyped(json, false);
}

export function ProviderCredentialFormDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProviderCredentialFormData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'allowEdit': !exists(json, 'allowEdit') ? undefined : json['allowEdit'],
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : BrandAndMarketListItemFromJSON(json['brandAndMarket']),
        'channel': !exists(json, 'channel') ? undefined : Int32IdAndLabelFromJSON(json['channel']),
        'agency': !exists(json, 'agency') ? undefined : GuidIdCodeAndLabelFromJSON(json['agency']),
        'provider': !exists(json, 'provider') ? undefined : GuidIdAndLabelFromJSON(json['provider']),
        'username': !exists(json, 'username') ? undefined : json['username'],
        'password': !exists(json, 'password') ? undefined : json['password'],
        'secretName': !exists(json, 'secretName') ? undefined : json['secretName'],
        'url': !exists(json, 'url') ? undefined : json['url'],
        'targetBranch': !exists(json, 'targetBranch') ? undefined : json['targetBranch'],
        'agencyId': !exists(json, 'agencyId') ? undefined : json['agencyId'],
        'agentName': !exists(json, 'agentName') ? undefined : json['agentName'],
        'agentPassword': !exists(json, 'agentPassword') ? undefined : json['agentPassword'],
        'agentSecretName': !exists(json, 'agentSecretName') ? undefined : json['agentSecretName'],
        'pcc': !exists(json, 'pcc') ? undefined : json['pcc'],
        'subscriptionKey': !exists(json, 'subscriptionKey') ? undefined : json['subscriptionKey'],
        'subscriptionKeySecretName': !exists(json, 'subscriptionKeySecretName') ? undefined : json['subscriptionKeySecretName'],
        'target': !exists(json, 'target') ? undefined : json['target'],
        'b2BAPIUserPasswordSecretName': !exists(json, 'b2BAPIUserPasswordSecretName') ? undefined : json['b2BAPIUserPasswordSecretName'],
        'b2BAPIUserPassword': !exists(json, 'b2BAPIUserPassword') ? undefined : json['b2BAPIUserPassword'],
        'b2BAPIUserEmailAddress': !exists(json, 'b2BAPIUserEmailAddress') ? undefined : json['b2BAPIUserEmailAddress'],
        'serviceUrl': !exists(json, 'serviceUrl') ? undefined : json['serviceUrl'],
        'clientId': !exists(json, 'clientId') ? undefined : json['clientId'],
        'clientSecret': !exists(json, 'clientSecret') ? undefined : json['clientSecret'],
        'authenticationUrl': !exists(json, 'authenticationUrl') ? undefined : json['authenticationUrl'],
        'accessGroup': !exists(json, 'accessGroup') ? undefined : json['accessGroup'],
        'shoppingUrl': !exists(json, 'shoppingUrl') ? undefined : json['shoppingUrl'],
        'shoppingClientId': !exists(json, 'shoppingClientId') ? undefined : json['shoppingClientId'],
        'shoppingClientSecret': !exists(json, 'shoppingClientSecret') ? undefined : json['shoppingClientSecret'],
        'shoppingServiceUrl': !exists(json, 'shoppingServiceUrl') ? undefined : json['shoppingServiceUrl'],
        'postShoppingUrl': !exists(json, 'postShoppingUrl') ? undefined : json['postShoppingUrl'],
        'postShoppingClientId': !exists(json, 'postShoppingClientId') ? undefined : json['postShoppingClientId'],
        'postShoppingClientSecret': !exists(json, 'postShoppingClientSecret') ? undefined : json['postShoppingClientSecret'],
        'postShoppingServiceUrl': !exists(json, 'postShoppingServiceUrl') ? undefined : json['postShoppingServiceUrl'],
    };
}

export function ProviderCredentialFormDataToJSON(value?: ProviderCredentialFormData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'allowEdit': value.allowEdit,
        'enabled': value.enabled,
        'brandAndMarket': BrandAndMarketListItemToJSON(value.brandAndMarket),
        'channel': Int32IdAndLabelToJSON(value.channel),
        'agency': GuidIdCodeAndLabelToJSON(value.agency),
        'provider': GuidIdAndLabelToJSON(value.provider),
        'username': value.username,
        'password': value.password,
        'secretName': value.secretName,
        'url': value.url,
        'targetBranch': value.targetBranch,
        'agencyId': value.agencyId,
        'agentName': value.agentName,
        'agentPassword': value.agentPassword,
        'agentSecretName': value.agentSecretName,
        'pcc': value.pcc,
        'subscriptionKey': value.subscriptionKey,
        'subscriptionKeySecretName': value.subscriptionKeySecretName,
        'target': value.target,
        'b2BAPIUserPasswordSecretName': value.b2BAPIUserPasswordSecretName,
        'b2BAPIUserPassword': value.b2BAPIUserPassword,
        'b2BAPIUserEmailAddress': value.b2BAPIUserEmailAddress,
        'serviceUrl': value.serviceUrl,
        'clientId': value.clientId,
        'clientSecret': value.clientSecret,
        'authenticationUrl': value.authenticationUrl,
        'accessGroup': value.accessGroup,
        'shoppingUrl': value.shoppingUrl,
        'shoppingClientId': value.shoppingClientId,
        'shoppingClientSecret': value.shoppingClientSecret,
        'shoppingServiceUrl': value.shoppingServiceUrl,
        'postShoppingUrl': value.postShoppingUrl,
        'postShoppingClientId': value.postShoppingClientId,
        'postShoppingClientSecret': value.postShoppingClientSecret,
        'postShoppingServiceUrl': value.postShoppingServiceUrl,
    };
}


